
import { useEffect } from "react";
import 'dotenv/config';

export default function DGAConnect() {
    useEffect(() => {
        let count = 0;
        const maxCount = 60;
        const interval = setInterval(() => {
            if (count >= maxCount) {
                clearInterval(interval);
            }

            console.log('DGA trying to connect');

            try {
                if (window.dga) {
                    window.dga.connect(process.env.REACT_APP_DGA_URL);
                    window.dga.onConnect = function () {
                        console.log('DGA connected');
                        window.dga.available(process.env.REACT_APP_DGA_CASINO_ID);
                    }
                    clearInterval(interval);
                }
                else {
                    count += 1;
                }
            } catch (error) {
                console.log('DGA connect error');
                count += 1;
            }
        }, 1000);

        return () => {
            try {
                clearInterval(interval);
                window.dga.disconnect();
            } catch (error) { }
        }
    }, []);

    return null;
}